export default "__VITE_PUBLIC_ASSET__895ec948__"